import * as React from "react";
import * as main from "../../../styles/main.module.scss";
import * as screen6 from "./screen6.module.scss";

export const HowWorks = ({ targetGroup, accessTimeText }) => { // 5-7 = kids, 8-11 = teens
  return (
    <section className={screen6.howWorks}>
      <div className="container">
        <h2 className={`${screen6.howWorks__title} ${main.title2}`}>Как устроен курс</h2>
        <div className={screen6.howWorks__block}>
          <div className={screen6.howWorks__block__wrapper}>
            <div className={`${screen6.howWorks__blockText} ${screen6.howWorks__blockText1}`}>
              <div className={screen6.blockText__title}>Обучение в удобное время</div>
              <div className={screen6.blockText__description}>и с той интенсивностью, которую выбирает ученик.</div>
            </div>
            <div className={`${screen6.howWorks__blockText} ${screen6.howWorks__blockText2}`}>
              <div className={screen6.blockText__title}>Мало теории и много практики:</div>
              <div className={screen6.blockText__description}>тренажёры и упражнения, позволяющие оценивать результаты и видеть
                динамику.
              </div>
            </div>
            <div className={`${screen6.howWorks__blockText} ${screen6.howWorks__blockText3}`}>
              <div className={screen6.blockText__title}>{accessTimeText}</div>
              <div className={screen6.blockText__description}>уроки после прохождения не закрываются, при необходимости к ним
                можно возвращаться.
              </div>
            </div>
            <div className={`${screen6.howWorks__blockText} ${screen6.howWorks__blockText4}`}>
              <div className={screen6.blockText__title}>Поддержка кураторов,</div>
              <div className={screen6.blockText__description}>которые помогут на всех этапах прохождения курса
                профессиональными советами по обучению и поддержанию мотивации.
              </div>
            </div>
          </div>
          <div className={screen6.howWorks__img__wrapper}>
            <div className={screen6.lessonExample__text}>Пример одного из уроков</div>
            {
              targetGroup === "kids" ?
                (<img
                    src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/primer-uroka.png"
                    alt={""}
                  />)
                :
                (<img
                    src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/primer-uroka-8-11.png"
                    alt={""}
                  />)
            }
            <div className={screen6.lessonDuration__block}>
              <div className={screen6.lessonDuration__num}>
                {
                  targetGroup === "kids" ?
                    "20"
                    :
                    "30"
                }
              </div>
              <div className={screen6.lessonDuration__min}>минут</div>
              <div className={screen6.lessonDuration__text}>длится один<br/>урок</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
